import { useState, useEffect, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { API_URL } from "../../config";
import axios from "axios";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";
import { PermissionWrapper } from "../../helpers/permission.js";

const StaffAttendance = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState(""); // 🔎 search state
  const limit = 100;
  const token = localStorage.getItem("authToken");

  const fetchNewAttendance = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}Attendance/attendance`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          limit,
          page,
        },
      });
      setUsers(response.data.data.users);
      setTotal(response.data.totalRecords);
      setPageCount(Math.ceil(response.data.totalRecords / limit));
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNewAttendance();
  }, [page]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pageCount) {
      setPage(newPage);
    }
  };

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  // 🔎 filter users by search (on current page data only)
  const filteredUsers = useMemo(() => {
    return users.filter((u) =>
      (u.user_fullname || "").toLowerCase().includes(search.toLowerCase())
    );
  }, [users, search]);

  return (
    <div className="page-header-fixed page-sidebar-fixed mt-5">
      {/* {loading && <LoadingSpinner />} */}
      <div className="panel panel-default with-rounded-corner with-shadow">
        <div className="d-flex align-items-center justify-content-between">
          <div className="panel-heading border-0">
            <h4 className="panel-title">Manage Staff Attendance</h4>
          </div>
          <div className="d-flex align-items-center me-3">
            {/* 🔎 Search box near pagination info */}
            <input
              type="text"
              className="form-control form-control-sm me-3"
              placeholder="Search..."
              style={{ maxWidth: "200px" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <span style={{ fontSize: "0.8rem", width: "110px" }} className="me-2">
              {start} to {end} of {total}
            </span>
            <button
              className="btn btn-default btn-sm"
              title="Previous"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 1}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            &nbsp;
            <button
              className="btn btn-default btn-sm"
              title="Next"
              onClick={() => handlePageChange(page + 1)}
              disabled={page === pageCount}
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table m-b-0">
            <thead>
              <tr>
                <th className="text-center">#</th>
                <th>Name</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 8 }).map((_, index) => (
                  <tr key={index} className="skeleton-row">
                    <td className="text-center">
                      <div className="skeleton-box" />
                    </td>
                    <td>
                      <div className="skeleton-box" />
                    </td>
                    <td>
                      <div className="skeleton-box" />
                    </td>
                  </tr>
                ))
              ) : Array.isArray(filteredUsers) && filteredUsers.length > 0 ? (
                filteredUsers.map((user, index) => (
                  <tr key={user.id}>
                    <td className="text-center">
                      {(page - 1) * limit + index + 1}
                    </td>
                    <td>{user.user_fullname}</td>
                    <td>
                      <PermissionWrapper module="hrms_staff_attendance" action="edit">
                        <Link
                          className="btn-warning btn-xs"
                          style={{ float: "left", marginRight: "10px" }}
                          to={`/Hrms/StaffAttendance/edit/${user.id}`}
                          title="Edit Attendance"
                        >
                          <i className="ti ti-pencil"></i>
                        </Link>
                      </PermissionWrapper>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      </div>
    </div>
  );
};

export default StaffAttendance;
